import { Injectable } from '@angular/core';
import { AssetSectionDto } from '@picflow/types';
import { Rect } from 'src/app/classes/rect.class';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { calcColumnCount } from 'src/app/lib/calc-column-count';
import { GalleryItem } from '../classes/gallery-item.class';
import { getGalleryWidth } from '../lib/get-gallery-width';

@Injectable({
  providedIn: 'root',
})
export class LayoutGridService {
  calculateAllItemPositions(section: AssetSectionDto, items: GalleryItem[], pageScale = 1, fullWidth = false): number {
    let galleryWidth = getGalleryWidth(section, fullWidth);

    let columnCount = calcColumnCount(section, galleryWidth);
    let columnWidth = Math.round(galleryWidth / columnCount);

    if (columnCount > items.length) {
      columnCount = items.length;
      galleryWidth = columnWidth * items.length;
    }

    galleryWidth = Math.round(galleryWidth * pageScale);
    columnWidth = Math.round(columnWidth * pageScale);

    items.forEach((item, i) => {
      if (!item.asset) return;
      this.calculateItemPosition(item, i, columnCount, columnWidth, section.spacing);
    });
    return galleryWidth;
  }

  calculateItemPosition(item: GalleryItem, index: number, columnCount: number, columnWidth: number, spacing: number) {
    if (ScreenSizes.screenSize() === 'mobile') spacing /= 2;
    const x = index % columnCount;
    const y = Math.floor(index / columnCount);

    const data = item.asset.version_data.data;

    const orientation = data && data.width > data.height ? 'horizontal' : 'vertical';
    item.bounds = new Rect(x * columnWidth, y * columnWidth, columnWidth, columnWidth);

    item.dimensions.x = Math.round(item.bounds.x + spacing);
    item.dimensions.y = Math.round(item.bounds.y + spacing);

    if (orientation === 'horizontal') {
      item.dimensions.width = columnWidth - spacing * 2;
      const scale = data ? data.width / item.dimensions.width : 1;
      const aspect = data ? data.height / (data.width + spacing * 2 * scale) : 1;
      item.dimensions.height = columnWidth * aspect;
      const spacingY = columnWidth - spacing * 2 - item.dimensions.height;
      item.dimensions.y += Math.round(spacingY / 2);
    } else {
      item.dimensions.height = columnWidth - spacing * 2;
      const scale = data ? data.height / item.dimensions.height : 1;
      const aspect = data ? data.width / (data.height + spacing * 2 * scale) : 1;
      item.dimensions.width = columnWidth * aspect;
      const spacingX = columnWidth - spacing * 2 - item.dimensions.width;
      item.dimensions.x += Math.round(spacingX / 2);
    }
  }
}
